;(function () {
	let blogSlider = null;
	let currentWidth = window.innerWidth;

	// Function to initialize desktop carousel (always active when enabled)
	const initDesktopCarousel = (slider) => {
		if (!slider) return;

		const navigation = slider.parentElement.querySelector('.blog__navigation');
		const pagination = slider.parentElement.querySelector('.blog__pagination');
		const columns = Number(slider.dataset.columns);
		let columns1200 = columns == 4 ? columns - 1 : columns;
		let columns990 = columns > 3 ? columns - 1 : columns;
		let columns576 = columns > 2 ? columns990 - 1 : columns990;

		blogSlider = new Swiper(slider, {
			loop: false,
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 300,
			mousewheel: {
				forceToAxis: true,
			},
			speed: 1000,
			navigation: {
				nextEl: navigation.querySelector('.swiper-button-next'),
				prevEl: navigation.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: pagination,
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: columns576,
					slidesPerGroup: columns576,
				},
				990: {
					slidesPerView: columns990,
					slidesPerGroup: columns990,
				},
				1200: {
					slidesPerView: columns1200,
					slidesPerGroup: columns1200,
				},
				1360: {
					slidesPerView: columns,
					slidesPerGroup: columns,
				},
			},
		});
	};

	// Function to initialize mobile slider (only on mobile)
	const initMobileSlider = (slider) => {
		if (!slider) return;

		slider.classList.add('swiper');

		const wrapper = slider.querySelector('.blog__posts-wrapper');
		
		if (!wrapper) return;

		wrapper.classList.add('swiper-wrapper');

		const slides = slider.querySelectorAll('.blog__post');
		
		if (!slides || !slides.length) return;

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide');
		});

		blogSlider = new Swiper(slider, {
		loop: false,
		slidesPerView: 1.1,
		spaceBetween: 16,
		speed: 300,
		mousewheel: {
			forceToAxis: true,
		},
	});
	};

	// Function to destroy mobile slider
	const destroyMobileSlider = (section) => {
		if (!section || !blogSlider) return;

		const slider = section.querySelector('.blog__mobile-slider');
		const slides = section.querySelectorAll('.blog__post');
		const wrapper = section.querySelector('.blog__posts-wrapper');

		if (!slider || !slides || !slides.length || !wrapper) return;

		slider.classList.remove('swiper');

		slides.forEach((slide) => {
			slide.classList.remove('swiper-slide');
		});

		wrapper.classList.remove('swiper-wrapper');

		blogSlider.destroy(true, true);
		blogSlider = null;
	};

	// Main initialization function
	const initSlider = (section) => {
		let parentSection;
		
		if (document.currentScript) {
			parentSection = document.currentScript.parentElement;
		} else {
			parentSection = section;
		}

		if (!parentSection) return;

		const slider = parentSection.querySelector('.blog__slider, .blog__mobile-slider');
		
		if (!slider) return;

		const isMobileSlider = slider.classList.contains('blog__mobile-slider');
		const isDesktopCarousel = slider.classList.contains('blog__slider');

		// If it's a desktop carousel (old behavior), initialize it normally
		if (isDesktopCarousel && !isMobileSlider) {
			initDesktopCarousel(slider);
			return;
		}

		// If it's a mobile slider, use ResizeObserver to handle responsiveness
		if (isMobileSlider) {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				const width = entry.contentRect.width;

				// Initialize slider on mobile (< 576px)
				if (width < 576 && !blogSlider) {
					initMobileSlider(slider);
				} 
				// Destroy slider on desktop (>= 576px)
				else if (width >= 576 && blogSlider) {
					destroyMobileSlider(parentSection);
				}
			});

			sectionResizeObserver.observe(parentSection);
		}
	};

	// Initialize on page load
	initSlider();

	// Re-initialize when section is loaded in theme editor
	document.addEventListener('shopify:section:load', function (section) {
		initSlider(section.target);
	});
})();